import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'decodeHtml', pure: true,
    standalone: false
})
export class decodeHtmlPipe implements PipeTransform {

  transform(content: any): string {
    if (content == undefined) {
      return "";
    }
    const txt = document.createElement('textarea');
    txt.innerHTML = String(content).split('&amp;').join('&');
    return txt.value;
  }
}
